import React from "react";
import classes from "./CardSkill.module.css";

const CardSkill = ({ text, classCard, img, blackText, time }) => {
  return (
    <div
      className={`${classes.CardSkill} ${classes[classCard]}`}
      style={{ height: time !== undefined ? "200px" : "180px" }}
    >
      <div className={classes.CardSkillInt}>
        <img src={img} alt={text} />
      </div>

      <div className={classes.CardSkillBottom}>
        {blackText ? <span className="black">{text}</span> : text}
      </div>
      {time !== undefined && <p className={classes.CardTime}>{time}</p>}
    </div>
  );
};

export default CardSkill;
